module.exports = __webpack_public_path__ + "assets/icon-filters-fdd3156b1860e9a3ca08d20346fd146a.svg";